import { useRef } from 'react';
import type { IServerSideDatasource } from 'ag-grid-community';

/**
 * Returns a stable datasource object reference whose `getRows` always delegates to the latest
 * datasource, avoiding SSRM churn when the underlying datasource identity changes (e.g. selection
 * re-renders) while keeping `serverSideDatasource` prop reference stable.
 */
export function useStableServerSideDatasource(
  datasource: IServerSideDatasource
): IServerSideDatasource {
  const datasourceRef = useRef(datasource);
  datasourceRef.current = datasource;
  const stableRef = useRef<IServerSideDatasource>({
    getRows: (params) => datasourceRef.current.getRows(params),
  });
  return stableRef.current;
}
